export const verificationUrl = () =>
  new URL('/signup/verification', window.location.origin).toString();
